import { useContext } from "react";
import { SettingsContext } from "../contexts/SettingContext.jsx";

const useSettings = () => useContext(SettingsContext);

export default useSettings;
